import { Certificate } from "models/interfaces/certificates/certificate";
import { RecordUtils } from "andculturecode-javascript-core";
import { AuditableRecord } from "models/auditable-record/auditable-record";
import { EnrollmentRecord } from "../enrollments/enrollment-record";
import { FileRecord } from "../files/file-record";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: Certificate = {
    fileId: undefined,
    error: undefined,
    status: undefined,
    enrollmentId: 0,
    title: undefined,
    expirationDate: undefined,
    enrollment: undefined,
    file: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class CertificateRecord extends AuditableRecord(defaultValues) {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<Certificate>) {
        params = params ?? Object.assign({}, defaultValues);

        if (params.enrollment != null) {
            params.enrollment = RecordUtils.ensureRecord(params.enrollment, EnrollmentRecord);
        }

        if (params.file != null) {
            params.file = RecordUtils.ensureRecord(params.file, FileRecord);
        }

        super(params);
    }

    // #endregion Constructor
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { CertificateRecord };

// #endregion Exports
